import { useEffect } from 'react';

import {
  useAppwatchSelector,
  useAppwatchDispatch,
  PaymentAnalysisActions,
} from '@wajeez-web/stores/appwatch';
import { Card } from '@wajeez-web/components/ui';
import { ChartHeader } from '../ChartHeader';
import { GrDocumentCsv } from 'react-icons/gr';
import { CSVLink } from 'react-csv';
import { ReturnTranslatedText } from '@wajeez-web/core/localization';

const ExpectedToBeLostPremiumsChart = () => {
  const dispatch = useAppwatchDispatch();
  const {
    expectedToBeLostPremiums,

    expectedToBeLostPremiumsStatus,
  } = useAppwatchSelector((c) => c.paymentAnalysis);

  useEffect(() => {
    dispatch(PaymentAnalysisActions.getExpectedToBeLostPremiumsAsync());
  }, []);

  return (
    <div className="col-span-2 ">
      {' '}
      <Card>
        <div className="space-y-2">
          <div className="flex flex-row justify-between">
            <ChartHeader
              title="Expected To Be Lost Premiums"
              subTitle={
                expectedToBeLostPremiumsStatus === 'loading'
                  ? ''
                  : 'المجموع :' + expectedToBeLostPremiums?.count
              }
            />
            <CSVLink
              data={expectedToBeLostPremiums?.list || []}
              filename={'expectedToBeLostPremiums.csv'}
            >
              <GrDocumentCsv size={20} />
            </CSVLink>
          </div>

          <div className="max-h-[600px] overflow-y-auto  ">
            {expectedToBeLostPremiumsStatus === 'loading' ? (
              <div className="loading h-[300px] flex justify-center items-center align-middle">
                <div className="spinner-border text-primary" role="status">
                  <span className="">
                    <ReturnTranslatedText text="general.Loading" />
                  </span>
                </div>
              </div>
            ) : (
              <table className=" table-auto w-full scrollbar-thin  ">
                <thead className="bg-[#E8F1F2] sticky top-0  border">
                  <tr className="h-12 font-bold text-start text-lg border ">
                    <th className="border border-gray-300 p-2">#</th>
                    <th className="border border-gray-300 p-2">الاسم</th>
                    <th className="border border-gray-300 p-2">
                      البريد الإلكتروني
                    </th>
                    <th className="border border-gray-300 p-2">مدة الإشتراك</th>
                  </tr>
                </thead>
                <tbody>
                  {expectedToBeLostPremiums?.list?.map((item, index) => (
                    <tr key={item.id}>
                      <td className="border border-gray-300 p-2">{item.id}</td>
                      <td className="border border-gray-300 p-2">
                        {item.name}
                      </td>
                      <td className="border border-gray-300 p-2">
                        {item.email}
                      </td>
                      <td className="border border-gray-300 p-2">
                        {item.subscriptionPeriod}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </Card>
    </div>
  );
};

export default ExpectedToBeLostPremiumsChart;
